const activeTokens = new Map<string, number>()

export const registerSquadAppToken = (appToken: string | undefined) => {
  if (!appToken) return () => undefined

  activeTokens.set(appToken, (activeTokens.get(appToken) ?? 0) + 1)

  return () => {
    const count = activeTokens.get(appToken) ?? 0

    if (count <= 1) {
      activeTokens.delete(appToken)
    } else {
      activeTokens.set(appToken, count - 1)
    }
  }
}

export const getActiveSquadAppToken = (): string | undefined =>
  activeTokens.keys().next().value
